module.exports = __webpack_public_path__ + "img/110-guinea.cc944c9e.svg";